import React from 'react';
import styled, {css, CSSObject} from 'styled-components';
import useMediaQuery from '../../hooks/useMediaQuery';

type StyledTextProps = {
  customStyles?: React.CSSProperties;
};

const StyledText = styled.div<StyledTextProps>`
  font-family: var(--font-family-head, vw-head);
  margin-block-start: 0;
  margin-block-end: 0;
  line-height: 110%;
  ${(props) => props.customStyles && css(props.customStyles as CSSObject)};
`;
type Size = 'small' | 'medium' | 'xMedium' | 'large' | 'xLarge' | 'xXLarge';

const fontSizeMap: Record<Size, number> = {
  large: 48,
  medium: 32,
  xMedium: 32,
  small: 20,
  xLarge: 60,
  xXLarge: 76,
};

const fontSizeMapMobile: Record<Size, number> = {
  large: 24,
  medium: 20,
  xMedium: 28,
  small: 16,
  xLarge: 32,
  xXLarge: 32,
};

interface Props {
  size?: Size;
  bold?: boolean;
  color?: React.CSSProperties['color'];
  children: React.ReactNode;
  style?: React.CSSProperties;
  textAlign?: React.CSSProperties['textAlign'];
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  className?: string;
}

const TypographyHeading = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const {
      size = 'medium',
      bold,
      children,
      style = {},
      color = '#fff',
      textAlign = 'left',
      tag = 'h3',
      className,
    } = props;

    const {isMobile} = useMediaQuery();
    return (
      <StyledText
        ref={ref}
        as={tag}
        customStyles={{
          fontWeight: bold ? '700' : '300',
          fontSize: isMobile ? fontSizeMapMobile[size] : fontSizeMap[size],
          color,
          textAlign,
          ...style,
        }}
        className={className}
      >
        {children}
      </StyledText>
    );
  },
);

TypographyHeading.displayName = 'TypographyHeading';

export default TypographyHeading;
